import { map } from 'lodash';
import type { ITicketCommercialLoanDetails } from './TicketCommercialLoanDetails.interface';
import TicketLoanDetailsSplit from './TicketLoanDetailsSplit';

export default class TicketCommercialLoanDetails implements ITicketCommercialLoanDetails {
  lender: string;
  loanApplicationNumber: string;
  term: number;
  lvr: number;
  dealCommercialLoanDetailsSplit: Array<TicketLoanDetailsSplit>;
  lmiCapitalised: boolean;
  lmi: number;
  offset: boolean;
  netBanking: boolean;
  creditCard: boolean;
  creditCardLimit: number;

  static build = (data: ITicketCommercialLoanDetails) => new TicketCommercialLoanDetails(data);
  static blank = () => new TicketCommercialLoanDetails();

  /**
   * Constructor
   * @param {ITicketCommercialLoanDetails} data
   */
  constructor(data?: ITicketCommercialLoanDetails) {
    this.lender = data?.lender || '';
    this.loanApplicationNumber = data?.loanApplicationNumber || '';
    this.term = parseInt(data?.term || 0, 10);
    this.lvr = parseInt(data?.lvr || 0, 10);
    this.dealCommercialLoanDetailsSplit = map(
      data?.dealCommercialLoanDetailsSplit,
      (obj) => new TicketLoanDetailsSplit(obj)
    );
    this.lmiCapitalised = data?.lmiCapitalised === true;
    this.lmi = parseInt(data?.lmi || 0, 10);
    this.offset = data?.offset === true;
    this.netBanking = data?.netBanking === true;
    this.creditCard = data?.creditCard === true;
    this.creditCardLimit = parseInt(data?.creditCardLimit || 0, 10);
  }
}
